import type { HttpMock } from '#e2e-utils/mockScenarios';

export const defaultCountryItMocks: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/userManagement/v2/internalUsers$',
    },
    response: {
      status: 200,
      body: [{ businessEmail: 'johndoe@gmail.fr', businessUnit: 'ITALY' }],
    },
  },
];
